import { library } from '@fortawesome/fontawesome-svg-core'
import { faPowerOff, faUser } from '@fortawesome/free-solid-svg-icons'

library.add(faPowerOff, faUser)
